import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GitCommit } from '@y42/git';

const ITEMS_LEFT_BEFORE_PRELOADING = 20;

@Component({
  selector: 'y42-git-commits-list',
  templateUrl: './git-commits-list.component.html',
  styleUrls: ['./git-commits-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitCommitsListComponent {
  @Input() commits: GitCommit[] = [];

  @Input() active: GitCommit | null = null;

  @Input() pageSize = 40;

  @Output() activeChange = new EventEmitter<GitCommit>();

  @Output() loadMore = new EventEmitter<void>();

  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  private lastTotalSize?: number;

  trackByFn(i: number, item: GitCommit) {
    return item.hash;
  }

  onScrolledIndexChanged() {
    const total = this.viewport.getDataLength();
    const end = this.viewport.getRenderedRange().end;
    if (this.lastTotalSize !== total && total >= this.pageSize && total - end < ITEMS_LEFT_BEFORE_PRELOADING) {
      this.lastTotalSize = total;
      this.loadMore.next();
    }
  }

  reset() {
    this.viewport?.scrollToIndex(0);
  }
}
